import { render, staticRenderFns } from "./PosterPage.vue?vue&type=template&id=1100c522&scoped=true"
import script from "./PosterPage.vue?vue&type=script&lang=js"
export * from "./PosterPage.vue?vue&type=script&lang=js"
import style0 from "./PosterPage.vue?vue&type=style&index=0&id=1100c522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1100c522",
  null
  
)

export default component.exports